module.exports = __webpack_public_path__ + "img/logo.e1c0aeb1.png";